import type { VehicleVariant } from "@spare-cart/contracts/vehicles";
import { getVertical } from "@spare-cart/core";

export type FuelTypeOption = { value: string; label: string };

export const fuelTypeOf = (variant: VehicleVariant): string | null =>
  typeof variant.attributes.fuelType === "string" ? variant.attributes.fuelType : null;

export const fuelTypeOptionsFrom = (variants: readonly VehicleVariant[]): FuelTypeOption[] => {
  const first = variants[0];
  if (first === undefined) return [];
  const vertical = getVertical(first.vehicleTypeSlug);
  const labelByValue = new Map(
    (vertical?.attributes.find((attribute) => attribute.key === "fuelType")?.options ?? []).map(
      (option) => [option.value, option.label],
    ),
  );
  const present = new Set(
    variants.map(fuelTypeOf).filter((value): value is string => value !== null),
  );
  return Array.from(present).map((value) => ({ value, label: labelByValue.get(value) ?? value }));
};
